import React, { useEffect } from 'react';
import { headers, baseUrl } from './common/credentials';


const port = "10003";
  

  export const getp2ptrackerlistFromServer = (prminputs) => {
    let url = baseUrl + port + "/po_process/p2p_team_prf_list/";
    return ([headers, url]); 
  }

  export const getp2ptrackerbyidFromServer = (prminputs) => {
    let url = baseUrl + port + "/po_process/p2p_team_prf_input_fields/";
    return ([headers, url]); 
  }